import { Resposta } from '../resposta/resposta.model';
import { OpcaoResposta } from '../resposta/opcao-resposta.model';
import { StringUtil } from 'src/app/core/framework/utils/string-util';
import { DefaultModel } from 'src/app/core/framework/default.model';
import { TipoItemQuestionario } from './model/tipo-item-questionario.enum';
import { Questao } from './model/questao.model';
import { QuestaoDTO } from './model/dto/questao-com-status-respondida.model';



export abstract class ItemQuestionario<T> extends DefaultModel {
  // tipo: TipoItemQuestionario;
  // nome: string;
  // descricao: string;
  // opcoes: OpcaoResposta[];
  // prerequisitoHm: string;
  // obrigatorio: boolean;
  // ordem: number;
  questao: QuestaoDTO;

  valor: T;
  resposta: Resposta;
  public emEdicao: boolean;
  public contraido: boolean;
  public emAvaliacao: boolean;

  constructor(options: {
    id?: number,
    tipo?: TipoItemQuestionario,
    valor?: T,
    nome?: string,
    descricao?: string,
    obrigatorio?: boolean,
    ordem?: number,
    opcoes?: OpcaoResposta[],
    resposta?: Resposta,
    prerequisitoHm?: string,
    emEdicao?: boolean,
    contraido?: boolean,
    emAvaliacao?: boolean
  } = {}) {
    super();

    this.questao = new QuestaoDTO();

    this.questao.tipo           = options.tipo; // || TipoItemQuestionario.DESCRITIVA
    this.questao.nome           = options.nome || '<< NOME DA QUESTÃO NÃO INFORMADO >>';
    this.questao.descricao      = options.descricao || '';
    this.questao.obrigatorio    = !!options.obrigatorio;
    this.questao.ordem          = options.ordem === undefined ? 1 : options.ordem;
    this.questao.opcoes         = options.opcoes === undefined ? new Array<OpcaoResposta>() : options.opcoes;
    this.questao.prerequisitoHm = options.prerequisitoHm;

    this.id             = options.id || StringUtil.getRandomInt();
    this.valor          = options.valor || null;
    this.resposta       = options.resposta === undefined ? new Resposta() : options.resposta;
    this.emEdicao       = !!options.emEdicao;
    this.contraido      = !!options.contraido;
    this.emAvaliacao    = !!options.emAvaliacao;
  }

  abstract getMaterialIcon(): string;

  abstract getLabel(): string;

  abstract isQuestaoEstruturada(): boolean;

  public getOpcoes(): OpcaoResposta[] {
    return this.questao.opcoes;
  }

  public setOpcoes(opcoes: OpcaoResposta[]): ItemQuestionario<T> {
    this.questao.opcoes = opcoes;
    return this;
  }

  public getNome(): string {
    return this.questao.nome;
  }

  public setNome(nome: string): ItemQuestionario<T> {
    this.questao.nome = nome;
    return this;
  }

  public getDescricao(): string {
    return this.questao.descricao;
  }

  public setDescricao(descricao: string): ItemQuestionario<T> {
    this.questao.descricao = descricao;
    return this;
  }

  public getId(): number {
    return this.id;
  }

  public setId(id: number): ItemQuestionario<T> {
    this.id = id;
    return this;
  }
}
